.datePicker {
    display: flex;
    flex-direction: row;
}

.clearIcon {
    padding-top: 32px;
}